!function(root, factory){

        factory(root, root.app);

}(this, function(root, app){

    // framerate from https://stackoverflow.com/questions/4298084/html5-frame-by-frame-viewing-frame-seeking
    // see: https://en.wikipedia.org/wiki/NTSC
    var FRAME_RATE = 29.97;
    var SECONDS_PER_FRAME = 1 / FRAME_RATE;

    function setCustomVideoLoopTimecode(video, timecode) {
        timecode = parseFloat(timecode);
        if (Number.isNaN(timecode)) {
            console.error('VideoCustomLoop: timecode must be a number');
            return;
        }

        video.addEventListener('ended', function(){
            video.currentTime = parseFloat(timecode);
            video.play();
        });
    }

    function setCustomVideoLoopFrame(video, frame) {
        frame = parseInt(frame, 10);
        if (Number.isNaN(frame)) {
            console.error('VideoCustomLoop: frame must be an integer');
            return;
        }

        setCustomVideoLoopTimecode(video, frame * SECONDS_PER_FRAME);
    }

    function init() {
        var $videos = $('video[data-loop-frame], video[data-loop-timecode]');
        $videos.each(function(index, video) {
            var loopTimecode = video.dataset.loopTimecode;
            var loopFrame = video.dataset.loopFrame;

            if (typeof loopTimecode !== 'undefined') {
                setCustomVideoLoopTimecode(video, loopTimecode);
            } else if (loopFrame !== 'undefined') {
                setCustomVideoLoopFrame(video, loopFrame);
            }
        });
    }

    app.extend({
        videoCustomLoop: {
            setCustomVideoLoopFrame: setCustomVideoLoopFrame,
            setCustomVideoLoopTimecode: setCustomVideoLoopTimecode,
            init: init
        }
    });

    return app.videoCustomLoop;
});
